import React, { useEffect, useState, useCallback } from "react"
import { FormControl } from "@mui/material"
import Input from "../Input/Input"
import { GOOGLE_MAPS_API_KEY } from "../../config/consts"


const PaymentAddressViewTab = ({ returnAddress, userData, setErrors, setFields }) => {
  const [addressData, setAddressData] = useState({
    address: userData?.address?.address || "",
    address2: "",
    city: userData?.address?.city || "",
    state: userData?.address?.state || "",
    zipcode: userData?.address?.zip || ""
  })

  const [addressInput, setAddressInput] = useState(userData?.address?.address || "")

  const handleInputChange = ({ target }) => {
    setAddressData({ ...addressData, [target.name]: target.value })
    setFields && setFields((prev) => ({ ...prev, [target.name]: target.value }))

    if (target) {
      setErrors && setErrors((prevErrors) => ({
        ...prevErrors,
        [target.name]: false,
      }))
    }
  }

  const handleAddressSelect = useCallback((place) => {
    const streetNumber = place.address_components.find(c => c.types.includes("street_number"))?.long_name || ""
    const route = place.address_components.find(c => c.types.includes("route"))?.long_name || ""
    const fullAddress = streetNumber ? `${streetNumber} ${route}` : route

    const address = {
      address: fullAddress,
      city: place.address_components.find(c => c.types.includes("locality"))?.long_name || "",
      state: place.address_components.find(c => c.types.includes("administrative_area_level_1"))?.short_name || "",
      zipcode: place.address_components.find(c => c.types.includes("postal_code"))?.long_name || ""
    }

    Object.keys(address).forEach((key) => {
      setErrors && setErrors((prevErrors) => ({
        ...prevErrors,
        [key]: false,
      }))
    })

    setAddressData(prev => ({ ...prev, ...address }))
    setFields && setFields((prev) => ({ ...prev, ...address }))
    setAddressInput(place.formatted_address)
  }, [setErrors, setFields, setAddressData, setAddressInput])

  // Ініціалізуємо Google Places Autocomplete
  useEffect(() => {
    const initAutocomplete = () => {
      if (window.google && window.google.maps && window.google.maps.places) {
        const input = document.getElementById('billing-address-input')
        if (input) {
          const autocomplete = new window.google.maps.places.Autocomplete(input, {
            types: ['address'],
            componentRestrictions: { country: 'us' },
            fields: ['address_components', 'formatted_address', 'geometry'],
            minLength: 1,
          })

          autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace()
            if (place.address_components) {
              handleAddressSelect(place)
            }
          })
        }
      }
    }

    if (!window.google || !window.google.maps || !window.google.maps.places) {
      const script = document.createElement('script')
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`
      script.async = true
      script.defer = true
      script.onload = initAutocomplete
      script.onerror = () => console.error('Failed to load Google Places API')
      document.head.appendChild(script)
    } else {
      initAutocomplete()
    }
  }, [handleAddressSelect])

  useEffect(() => {
    returnAddress && returnAddress(addressData)
  }, [addressData, returnAddress])

  useEffect(() => {
    setFields && setFields({
      address: userData?.address?.address || "",
      city: userData?.address?.city || "",
      state: userData?.address?.state || "",
      zipcode: userData?.address?.zip || ""
    })
  }, [userData, setFields])

  return (
    <div className="w-full">
      <div>


      </div>
      <FormControl className="w-full">
        <div className="flex justify-start flex-col text-text-secondary">
          <span className="ml-4 mb-2 text-md text-start max-w-max">Billing Address</span>
          <input
            id="billing-address-input"
            placeholder="Enter your address..."
            value={addressInput}
            onChange={(e) => {
              setAddressInput(e.target.value)
              setAddressData(prev => ({ ...prev, address: e.target.value }))
              setFields && setFields(prev => ({ ...prev, address: e.target.value }))
            }}
            className="py-4 px-3.5 text-text-primary text-lg font-normal rounded-lg focus:outline-none border border-divider hover:border-text-primary focus:border-text-primary placeholder:text-text-secondary w-full bg-transparent"
            style={{
              height: '54.5px',
              position: 'relative',
              zIndex: 1000
            }}
          />
          <style jsx>{`
            .pac-container {
              z-index: 9999 !important;
              position: absolute !important;
              background: var(--color-bg-paper) !important;
              border: 1px solid var(--color-divider) !important;
              border-radius: 8px !important;
              box-shadow: 0 2px 6px rgba(0,0,0,0.3) !important;
            }
            .pac-item {
              padding: 8px 12px !important;
              cursor: pointer !important;
              color: var(--color-text-primary) !important;
            }
            .pac-item:hover {
              background-color: var(--color-gray-150) !important;
            }
          `}</style>
        </div>
        {/*<Input*/}
        {/*  label="Billing Address"*/}
        {/*  placeholder="Enter Full Address"*/}
        {/*  value={addressData.address}*/}
        {/*  type="text"*/}
        {/*  name="address"*/}
        {/*  className="form-control"*/}
        {/*  required={true}*/}
        {/*  onAddressSelect={handleAddressSelect}*/}
        {/*  addressType="city"*/}
        {/*  onChange={handleInputChange}*/}
        {/*/>*/}
        <Input
          label="Billing Address 2"
          placeholder="Enter Address"
          value={addressData.address2}
          type="text"
          name="address2"
          className="form-control"
          parentClassName="mt-5"
          required={true}
          onChange={handleInputChange}
        />
        <div className="flex gap-4 flex-col md:flex-row">
          <Input
            label="City"
            placeholder="Enter City"
            value={addressData.city}
            type="text"
            name="city"
            className="form-control"
            parentClassName="mt-5"
            required={true}
            width="w-full md:w-[185px]"
            onChange={handleInputChange}
          />
          <Input
            label="State"
            placeholder="Enter State"
            value={addressData.state}
            type="text"
            name="state"
            className="form-control"
            parentClassName="mt-5"
            required={true}
            width="w-full md:w-[185px]"
            onChange={handleInputChange}
          />
          <Input
            label="Zip"
            placeholder="Enter Zip"
            value={addressData.zipcode}
            type="number"
            name="zipcode"
            className="form-control"
            parentClassName="mt-5"
            required={true}
            width="w-full md:w-[185px]"
            onChange={handleInputChange}
          />
        </div>
      </FormControl>
    </div>
  )
}

export default PaymentAddressViewTab
